<template>
  <div v-if="config">
    <!--table 
      border="1"
      v-if="mapConfig && mapConfig.length > 1"
      style="position: absolute;z-index: 7;width:80%;margin-top: 200px;">
      <tr>
        <td style="width: 40px;padding-left:10px;"  @click="handleChangeMap(-1)">
          <div style="background-color: #00000080;width:35px;border-radius:50%;padding:5px;">
            <v-icon color="white">mdi-arrow-u-right-bottom-bold</v-icon>
          </div>
        </td>
        <td style="width:auto;">
        </td>
        <td style="width: 40px;text-align:right;" @click="handleChangeMap(1)">
          <div style="background-color: #00000080;width:35px;border-radius:50%;padding:5px;">
            <v-icon color="white">mdi-arrow-u-left-bottom-bold</v-icon>
          </div>
        </td>
      </tr>
    </table-->
    <custom-canvas
      v-if="configPoints"
      :key="configPoints.id"
      :config="configPoints"
      :locale="locale"
      :isDesktop="isDesktop"
      :multiZone="mapConfig && mapConfig.length > 1"
      :onChangeMap="(v) => { handleChangeMap(v)}"
    />
  </div>
</template>
<script>
import apiDtouch from '@/services/apiDtouch'
import utils from '@/services/utils'
import CustomCanvas from './CustomCanvas'
export default {
  name:'Item57InteractiveMaps',
  components: {
    CustomCanvas,
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    mapConfig: null,
    actualMap: 0,
    configPoints: null,
    oldWidth: null,
  }),
  computed: {
    workspaceID () {
      return this.$store.state.app.dtouchWorkspace
      //return utils.getWorkspaceIdentification ()
    },
  },
  mounted () {
    this.handleGetData()
    const that = this
    window.addEventListener("resize", function() {
      const w = (document.getElementsByClassName('main-content-items')[0].clientWidth)
      if (w !== that.oldWidth) that.handleGetData()
    })
  },
  methods: {
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    handleChangeMap (p) {
      this.configPoints = null
      if (!p) {
        this.actualMap = 0
      } else if (p > 0) {
        if (this.actualMap + 1 === this.mapConfig.length) {
          this.actualMap = 0
        } else {
          this.actualMap++
        }
      } else if (p < 0) {
        if (this.actualMap - 1 < 0) {
          this.actualMap = this.mapConfig.length - 1
        } else {
          this.actualMap--
        }
      }
      const v = this.mapConfig[this.actualMap]
      if (!v) return
      const w = (document.getElementsByClassName('main-content-items')[0].clientWidth)
      this.oldWidth = w
      //const scale = w > v.Width ? 1 : w / v.Width
      const scale =  w / v.Width
      const width = v.Width * scale | 0
      const height = v.Height * scale | 0

      this.configPoints = {
        id: v.ID,
        background: v.Image,
        scale,
        width,
        height,
        points: v.points,
        categories: v.categories,
      }
    },
    async handleGetData () {
      this.configPoints = null
      try {
        if (!this.content.InteractiveMapsID) return
        const mapConfig = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.content.InteractiveMapsID}/map-config`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))
        if (!mapConfig || mapConfig.length === 0) return

        for (let m of mapConfig) {
          m.categories = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${m.ID}/categories`)
          .then(response => {
            if (response && response.length > 0) {
              response = response.map(item => {
                item.Name = JSON.parse(item.Name)
                return item
              })
              response.unshift({
                ID: null,
                Icon: 'mdi-folder',
                Name: { es: 'TODOS', en: 'ALL'}
              })
            }
            resolve(response)
          }).catch (error => {
            reject(error)
          }))


          m.points = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${m.ID}/points`)
            .then(response => {
              resolve(response.map(item => {
                item.Title = JSON.parse(item.Title)
                item.Description = JSON.parse(item.Description)
                item.Info = item.Info ? JSON.parse(item.Info) : null
                return item
              }))
            }).catch (error => {
              reject(error)
            }))
        }

        this.mapConfig = mapConfig
        this.handleChangeMap(this.mapConfig[this.actualMap])
        /*

        const categories = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.content.InteractiveMapsID}/categories`)
          .then(response => {
            if (response && response.length > 0) {
              response = response.map(item => {
                item.Name = JSON.parse(item.Name)
                return item
              })
              response.unshift({
                ID: null,
                Icon: 'mdi-folder',
                Name: { es: 'TODOS', en: 'ALL'}
              })
            }
            resolve(response)
          }).catch (error => {
            reject(error)
          }))

        const map = await new Promise((resolve, reject) => apiDtouch.getItem(`v2/public/interactive-maps/${this.content.InteractiveMapsID}`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))
        const points = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.content.InteractiveMapsID}/points`)
          .then(response => {
            resolve(response.map(item => {
              item.Title = JSON.parse(item.Title)
              item.Description = JSON.parse(item.Description)
              item.Info = item.Info ? JSON.parse(item.Info) : null
              return item
            }))
          }).catch (error => {
            reject(error)
          }))
        const w = (document.getElementsByClassName('main-content-items')[0].clientWidth)
        this.oldWidth = w
        //const scale = w > v.Width ? 1 : w / v.Width
        const scale =  w / map.Width
        const width = map.Width * scale | 0
        const height = map.Height * scale | 0

        this.configPoints = {
          background: map.Image,
          scale,
          width,
          height,
          points,
          categories,
        }
        */
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style scoped>
  .requests-result {
    table-layout: fixed;
    width: 100% !important;
    max-width: 100% !important;
  }
  .requests-result .name {
    width: auto;
    line-height: 1;
  }
  .requests-result .action {
    width: 100px;
    /*white-space: nowrap;*/
    text-align: right;
    vertical-align: top;
  }
</style>


